// src/components/auth/ChangePassword.tsx

import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Avatar,
    Alert,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import { LockReset as LockResetIcon } from '@mui/icons-material';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePassword: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                p: 2,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 3, sm: 4 },
                    width: '100%',
                    maxWidth: 460,
                    borderRadius: 2,
                }}
            >
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                    <Avatar
                        sx={{
                            bgcolor: 'warning.main',
                            width: 56,
                            height: 56,
                            mx: 'auto',
                            mb: 2,
                        }}
                    >
                        <LockResetIcon fontSize="large" />
                    </Avatar>
                    <Typography variant={isMobile ? 'h5' : 'h4'} sx={{ fontWeight: 600, mb: 0.5 }}>
                        Смена пароля
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Пароль был установлен по умолчанию
                    </Typography>
                </Box>

                <Alert severity="info" sx={{ mb: 3 }}>
                    <Typography variant="body2">
                        Для продолжения работы необходимо <strong>сменить пароль по умолчанию</strong>.
                        Придумайте новый пароль и запомните его.
                    </Typography>
                </Alert>

                <ChangePasswordForm />
            </Paper>
        </Box>
    );
};

export default ChangePassword;